export default "__VITE_ASSET__10UOuFY0__"